module.exports = __webpack_public_path__ + "media/theme/Mobage-7b03bde1.svg";